// extracted by mini-css-extract-plugin
export var avatarBone = "_5-5";
export var body = "_5-b";
export var bone = "_5-0";
export var brandGroup = "_5-4";
export var cardBone = "_5-i";
export var descBone = "_5-f";
export var divider = "_5-a";
export var grid = "_5-h";
export var header = "_5-2";
export var iconTagBone = "_5-8";
export var leftColumn = "_5-c";
export var leftInner = "_5-d";
export var nameBone = "_5-6";
export var navBar = "_5-3";
export var rightColumn = "_5-g";
export var rightGroup = "_5-7";
export var skeletonPulse = "_5-1";
export var tagBone = "_5-9";
export var titleBone = "_5-e";